import { defineMessages } from 'react-intl';

export const entityMessages = defineMessages({
    people: {
        id: 'people',
        defaultMessage: 'People',
    },
    person: {
        id: 'person',
        defaultMessage: 'Person',
    },
    groups: {
        id: 'groups',
        defaultMessage: 'Groups',
    },
    group: {
        id: 'group',
        defaultMessage: 'Group',
    },
    subgroups: {
        id: 'subgroups',
        defaultMessage: 'Subgroups',
    },
    subgroup: {
        id: 'subgroup',
        defaultMessage: 'Subgroup',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    phone: {
        id: 'phone',
        defaultMessage: 'Phone',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    identificationCode: {
        id: 'identification-code',
        defaultMessage: 'Identification code',
    },
    createPersonEntitySuccess: {
        id: 'create-person-entity-success',
        defaultMessage: '{entity} created',
    },
    createPersonEntitySuccessDescription: {
        id: 'create-person-entity-success-description',
        defaultMessage: 'A new {entity} has been successfully created.',
    },
    newPersonEntity: {
        id: 'add-new-person-entity',
        defaultMessage: 'New {entity}',
    },
    addPersonEntityModalSubtitle: {
        id: 'add-person-entity-modal-subtitle',
        defaultMessage: 'Add a new {entity}',
    },
    createGroupEntitySuccess: {
        id: 'create-group-entity-success',
        defaultMessage: '{entity} created',
    },
    createGroupEntitySuccessDescription: {
        id: 'create-group-entity-success-description',
        defaultMessage: 'A new {entity} has been successfully created.',
    },
    newGroupEntity: {
        id: 'add-new-group-entity',
        defaultMessage: 'New {entity}',
    },
    addGroupEntityModalSubtitle: {
        id: 'add-group-entity-modal-subtitle',
        defaultMessage: 'Add a new {entity}',
    },
    personDashboard: {
        id: 'person-dashboard',
        defaultMessage: 'Person dashboard',
    },
    groupDashboard: {
        id: 'group-dashboard',
        defaultMessage: 'Group dashboard',
    },
    deleteEntity: {
        id: 'delete-entity',
        defaultMessage: 'Delete {entry}',
    },
    deleteEntitySubtitle: {
        id: 'delete-entity-subtitle',
        defaultMessage: 'Permanently delete {entry}',
    },
    confirmDeleteEntity: {
        id: 'confirm-delete-entity',
        defaultMessage: 'Are you sure you want to delete {entry}? This action cannot be undone.',
    },
    deleteEntitySuccess: {
        id: 'delete-entity-success',
        defaultMessage: 'Deleted',
    },
    deleteEntitySuccessDescription: {
        id: 'delete-entity-success-description',
        defaultMessage: '{entry} has been successfully deleted.',
    },
    editEntitySubtitle: {
        id: 'edit-entity-subtitle',
        defaultMessage: 'Edit details for {entry}',
    },
    updateEntitySuccess: {
        id: 'update-entity-success',
        defaultMessage: 'Details updated',
    },
    updateGroupSuccessDescription: {
        id: 'update-group-success-description',
        defaultMessage: 'The group has been successfully updated.',
    },
    updatePersonSuccessDescription: {
        id: 'update-person-success-description',
        defaultMessage: 'The person has been successfully updated.',
    },
    searchGroup: {
        id: 'search-group',
        defaultMessage: 'Search for group',
    },
    entity: {
        id: 'entity',
        defaultMessage: 'Entity',
    },
    entities: {
        id: 'entities',
        defaultMessage: 'Entities',
    },
});
